import { useFieldArray } from "react-hook-form"
import {
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import { Cross2Icon } from "@radix-ui/react-icons"
import { z } from "zod"
import { invoiceSchema } from "./invoice.schema"

export default function InvoiceItemsForm() {
  const { fields, append, remove, update } = useFieldArray<
    z.input<typeof invoiceSchema>
  >({ name: "items" })

  const addItem = () =>
    append({ description: "", quantity: "", unitValue: "" })

  return (
    <div className="flex flex-col space-y-4 flex-grow">
      <div className="flex flex-row gap-2 flex-grow">
        <div className="flex flex-row gap-4 flex-grow">
          <div className="text-sm font-semibold w-6/12">
            <FormLabel required>Description</FormLabel>
          </div>
          <div className="text-sm font-semibold w-3/12">
            <FormLabel required>QTY</FormLabel>
          </div>
          <div className="text-sm font-semibold w-3/12">
            <FormLabel required>Price</FormLabel>
          </div>
        </div>
      </div>
      {fields.map((field, index: number) => (
        <div key={index} className="flex flex-row gap-2 flex-grow">
          <FormField
            name={`items[${index}].description`}
            render={() => (
              <FormItem className="w-6/12">
                <Input
                  name={`items[${index}].description`}
                  placeholder="Add item..."
                  value={field.description}
                  onChange={(e) =>
                    update(index, { ...field, description: e.target.value })
                  }
                />
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            name={`items[${index}].quantity`}
            render={() => (
              <FormItem className="w-3/12">
                <Input
                  name={`items[${index}].quantity`}
                  value={field.quantity}
                  onChange={(e) =>
                    update(index, { ...field, quantity: e.target.value })
                  }
                  type="number"
                />
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            name={`items[${index}].unitValue`}
            render={() => (
              <FormItem className="w-3/12">
                <Input
                  name={`items[${index}].unitValue`}
                  value={field.unitValue}
                  onChange={(e) =>
                    update(index, { ...field, unitValue: e.target.value })
                  }
                  type="number"
                />
                <FormMessage />
              </FormItem>
            )}
          />
          <Button
            variant="ghost"
            size="sm"
            className="border-0"
            onClick={() => remove(index)}
            disabled={fields.length === 1}
            type="button"
          >
            <Cross2Icon />
          </Button>
        </div>
      ))}
      <div className="flex flex-row justify-end">
        <Button variant="outline" onClick={addItem} type="button">
          Add item
        </Button>
      </div>
    </div>
  )
}
